/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

export default {
    ADD: 0,
    EDIT: 1
}